module.exports = __webpack_public_path__ + "img/kr.47cdffe6.jpg";